"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixEmptySqrt = fixEmptySqrt;
function fixEmptySqrt(tex) {
    return tex.replace(new RegExp(`\\\\sqrt\\s*{\\s*}`, "g"), "\\sqrt{\\vphantom1}");
}
